<template>
  <p
    class="text-center text-[#999999]"
    :class="isPC ? 'text-[16px]' : 'text-[28px]'"
  >
    {{ label }}
    <span class="font-bold text-[#FF7D00]">{{ countdownText }}</span>
  </p>
</template>

<script lang="ts">
import { computed, onBeforeUnmount, onMounted, ref } from 'vue-demi';
import { useFegoPageInfo } from '@ark/web-shared/use';
const __sfc_main = {};
__sfc_main.props = {
  deadline: {
    key: "deadline",
    required: true,
    type: Number
  },
  label: {
    key: "label",
    required: false,
    type: String,
    default: '距活动截止: '
  },
  dayUnit: {
    key: "dayUnit",
    required: false,
    type: String,
    default: '天'
  },
  hourUnit: {
    key: "hourUnit",
    required: false,
    type: String,
    default: '时'
  },
  minuteUnit: {
    key: "minuteUnit",
    required: false,
    type: String,
    default: '分'
  },
  secondUnit: {
    key: "secondUnit",
    required: false,
    type: String,
    default: '秒'
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;
  const {
    isPC
  } = useFegoPageInfo();
  const now = ref(Date.now());
  let timer: ReturnType<typeof setInterval> | null = null;
  function pad(value: number): string {
    if (value === 0) return '0';
    return value < 10 ? `0${value}` : `${value}`;
  }
  const remainingMs = computed(() => Math.max(0, props.deadline - now.value));
  const countdownText = computed(() => {
    const totalSeconds = Math.floor(remainingMs.value / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor(totalSeconds % 86400 / 3600);
    const minutes = Math.floor(totalSeconds % 3600 / 60);
    const seconds = totalSeconds % 60;
    return `${days}${props.dayUnit} ${pad(hours)}${props.hourUnit} ${pad(minutes)}${props.minuteUnit} ${pad(seconds)}${props.secondUnit}`;
  });
  function clear() {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  }
  onMounted(() => {
    timer = setInterval(() => {
      now.value = Date.now();
      if (remainingMs.value <= 0) {
        clear();
        emit('finish');
      }
    }, 1000);
  });
  onBeforeUnmount(clear);
  return {
    isPC,
    countdownText
  };
};
export default __sfc_main;
</script>
